import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { CalendlyButton } from "./CalendlyButton";
import { SITE } from "../config/site";

/** Reusable bright pre-footer CTA. Never a large dark block. */
export function CTASection({
  eyebrow = "Consultations",
  headline = "Protect What You've Built.",
  copy = "Speak with a legal team prepared to understand your goals, evaluate your options, and help you take the next step.",
  showCall = true,
  testid = "cta-section",
}) {
  const hasPhone = SITE.phone && SITE.phone !== "To be added";
  return (
    <section className="relative overflow-hidden bg-cream py-20 md:py-28" data-testid={testid}>
      <div className="arch-grid pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-4xl px-5 text-center md:px-8">
        <Reveal>
          <p className="text-xs font-600 uppercase tracking-label text-gold">{eyebrow}</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-serif text-4xl font-500 leading-[1.05] text-navy sm:text-5xl">
            {headline}
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-bluegray-text md:text-lg">
            {copy}
          </p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid={`${testid}-request`}
              className="group inline-flex items-center gap-2 rounded-sm bg-navy px-8 py-4 text-sm font-600 text-white transition-colors duration-300 hover:bg-navy-light"
            >
              Request Consultation
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.8} />
            </Link>
            <CalendlyButton testid={`${testid}-calendly`} />
            {showCall && (
              hasPhone ? (
                <a href={`tel:${SITE.phoneRaw}`} data-testid={`${testid}-call`}
                  className="inline-flex items-center gap-2 rounded-sm border border-navy/25 px-8 py-4 text-sm font-600 text-navy transition-colors hover:border-gold">
                  <Phone className="h-4 w-4" strokeWidth={1.6} /> Call {SITE.phone}
                </a>
              ) : (
                <span
                  data-testid={`${testid}-call-disabled`}
                  aria-disabled="true"
                  title="Phone number coming soon"
                  className="inline-flex cursor-not-allowed items-center gap-2 rounded-sm border border-navy/15 px-8 py-4 text-sm font-600 text-navy/40"
                >
                  <Phone className="h-4 w-4" strokeWidth={1.6} /> Call the Office
                </span>
              )
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
